// // import emailjs from "emailjs-com";
// // import React from 'react';
// // // import '../App.css'

// // export default function ContactUs(props) {
// //     // const [method, setMethod]= useState('1000 for one year')

// //     function sendEmail(e) {
// //         e.preventDefault();

// //     emailjs.sendForm ('service_ugaq30d', 'template_s3u9xer', e.target, '9iHxq_nQ73QyLrcuG')
   
// //         .then((result) => {
// //             console.log(result.text);
// //         }, (error) => {
// //             console.log(error.text);
// //         });
// //         e.target.reset()
// //         alert('We will work on your request ASAP.')
// //         // window.location.reload()
// //     }

// //     var ms = new Date().getTime() + 86400000;
// //     var tomorrow = new Date(ms).toLocaleString().slice(0, 9)

// //     return(
// //         <div>
// //             <div className="container">
                
// //             <h3>Contact Us</h3>
// //             {/* 
// //             <select id="Methods" onChange={e => props.setMethod(e.target.value)}>
// //             <option value="-"></option>
// //                   <option  value="$975 for one year">Annual - $975</option>
// //                   <option value="$90 every month">Monthly - $90</option>
                  
// //                 </select> */}
// //             <form onSubmit={sendEmail}>
// //                     <div className="row pt-5 mx-auto">
// //                         <div className="col-8 form-group mx-auto">
// //                             <input type="text" className="for" value={"Online Shop"} name="from_name" readOnly={true}/>
// //                         </div>
// //                         <div className="col-8 form-group pt-2 mx-auto">
// //                             <input type="email" className="for" placeholder="Your Email Address" name="user_email"/>
// //                         </div>
// //                         <div className="col-8 form-group pt-2 mx-auto">
// //                             <input type="text" className="for" placeholder="Subject" name="subject"/>
// //                         </div>
// //                         <div className="col-8 form-group pt-2 mx-auto">
// //                             <textarea className="fo" id="" cols="30" rows="8" placeholder="Your message..." name="message"></textarea>
// //                         </div>
// //                         <div className="col-8 pt-3 mx-auto">
// //                             <input type="submit" className="btn" value="Send Message"></input>
// //                         </div>
// //                     </div>
// //                 </form>
// //             </div>
// //         </div>
// //     )
// // }
import { MdChargingStation } from "react-icons/md";
import emailjs from "emailjs-com";
import "../p.css";
// https://uideck.com/blog/html-contact-forms
export default function ContactUs(props) {


      function sendEmail(e) {
        e.preventDefault();
        emailjs.sendForm ('service_ra0tzqd', 'template_dcrf6kr', e.target, "K6B2QrefJnYCDCTa1")
    // emailjs.sendForm ('service_ugaq30d', 'template_s3u9xer', e.target, '9iHxq_nQ73QyLrcuG')
   
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
        alert('We will work on your request ASAP.')
        // window.location.reload()
    }

    var ms = new Date().getTime() + 86400000;
    var tomorrow = new Date(ms).toLocaleString().slice(0, 9)
  return (
    <div className="container2" >
      <div className="form-container">
        <div className="left-container">
          <div className="left-inner-container">
            <h2>Let's Chat</h2>
            <p>
              Whether you have a question, want to start a project or simply
              want to connect.
            </p>
            <p>Feel free to send us a message in the contact form.</p>
          </div>
        </div>
        <div className="right-container">
          <div className="right-inner-container">
            <form onSubmit={sendEmail}>
            <div className="top-container">
          <div className="top-inner-container">
          <h2 style={{ marginTop:-20}} className="form-title">Contact</h2>
            <p style={{color:"white", marginTop:-10}}>
              Whether you have a question, want to start a project or simply
              want to connect.
            </p>

          </div>
        </div>
            
              {/* <p style={{fontSize:10, color:"red"}}>* Required</p> */}
              {/* <div className="social-container">
                <a href="#" className="social">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="social">
                  <i className="fab fa-google-plus-g"></i>
                </a>
                <a href="#" className="social">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div> */}
              {/* <input type="text" placeholder="Name *" /> */}
              <div style={{   padding:10, borderRadius:10}}>
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="text" className="for" placeholder="Subject" name="to_name"/>
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="text" className="for" placeholder="Your name" name="from_name" />
              {/* <input type="email" placeholder="Email *" /> */}
              <input style={{backgroundColor:"#efd2f3c2", borderRadius:8}}type="email" className="for" placeholder="Your Email Address" name="from_email"/>
              {/* <input type="phone" placeholder="Phone" /> */}
              <textarea style={{backgroundColor:"#efd2f3c2", borderRadius:8}}className="fo" id="" cols="30" rows="4" placeholder="Your message..." name="message"></textarea>
              {/* <textarea rows="4" placeholder="Message"></textarea> */}
              </div>
              <input  id ="ptr" type="submit" className="btn" value="Send Message"></input>
              {/* <button>Submit</button> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

// ……………………………….


          {/* <div style={{ alignItems: "center", display: "flex", justifyContent: "space-between", alignItems: "center", padding:30 }}>
          <button id= 'contact'  onClick={handleClick} style={{color:"white", background:"black", marginTop:10, maxWidth:200, width:100, height:45}}> Contact Us</button>
          </div> */}

  // const handleClick = () => {
  //   navigate('/Contact-us');
  // };
{/* <Route path="/Contact-us" element={<ContactUs />} /> */}

